// Mock data pour le site Déclic
export const siteData = {
  business: {
    name: "Déclic",
    tagline: "Le déclic qui change tout",
    description: "Coaching sportif personnalisé & suivi nutritionnel à Lingolsheim",
    phone: "06 76 45 26 13",
    address: "32 Rue des Muguets",
    city: "67380 Lingolsheim",
    email: "contact@declic-coaching.fr",
    instagram: "https://instagram.com/declic.coaching?igshid=YmMyMTA2M2Y=",
    rating: 5.0,
    reviewCount: 59,
    views: 2333,
    hours: "Ouvert – ferme à 20:00",
    lgbtqFriendly: true
  },

  images: {
    hero: "https://images.unsplash.com/photo-1534258936925-c58bed479fcb",
    coaching1: "https://images.unsplash.com/photo-1648542036561-e1d66a5ae2b1",
    coaching2: "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b",
    nutrition: "https://images.unsplash.com/photo-1584466977773-e625c37cdd50",
    about: "https://images.unsplash.com/photo-1524758870432-af57e54afa26",
    transformation: "https://images.unsplash.com/uploads/14122810486321888a497/1b0cc699",
    consultation: "https://images.unsplash.com/photo-1511376979163-f804dff7ad7b",
    professional: "https://images.unsplash.com/photo-1551836022-d5d88e9218df"
  },

  services: [
    {
      id: 1,
      title: "Coaching Sportif Personnalisé",
      description: "Programme sur-mesure adapté à tes objectifs : perte de poids, prise de masse musculaire, remise en forme ou préparation physique.",
      icon: "dumbbell",
      features: ["Séances individuelles", "Programme adapté", "Suivi personnalisé", "En salle ou à domicile"]
    },
    {
      id: 2,
      title: "Suivi Nutritionnel Complet",
      description: "Un accompagnement nutritionnel adapté à ton mode de vie et tes objectifs pour optimiser tes résultats.",
      icon: "apple",
      features: ["Plan alimentaire personnalisé", "Conseils nutrition", "Suivi régulier", "Recettes adaptées"]
    },
    {
      id: 3,
      title: "Accompagnement Global",
      description: "Suivi complet sport + nutrition avec application dédiée pour suivre ta progression au quotidien.",
      icon: "target",
      features: ["Application de suivi", "Motivation continue", "Objectifs clairs", "Résultats mesurables"]
    }
  ],

  values: [
    { title: "À l'écoute", description: "Ton coach prend le temps de comprendre tes besoins et s'adapte à ton rythme.", icon: "ear" },
    { title: "Bienveillant", description: "Un accompagnement sans jugement, dans la bonne humeur et la motivation.", icon: "heart" },
    { title: "Expert technique", description: "Des connaissances solides et une passion du sport au service de ta progression.", icon: "award" },
    { title: "Résultats durables", description: "Des méthodes éprouvées pour des transformations qui durent dans le temps.", icon: "trending-up" }
  ],

  testimonials: [
    {
      id: 1,
      name: "Marie-Julie Tavernier",
      rating: 5,
      text: "Kévin est un super coach que je conseille à 100% ! Cela fait presque un an qu'on travaille ensemble et je suis vraiment très satisfaite. Le suivi est très complet (sport + nutrition), avec une application dédiée et surtout une approche sur-mesure. Il s'adapte à mes incapacités 😅 tout en me poussant à me dépasser. Beaucoup de disponibilité et de souplesse d'organisation aussi, c'est précieux pour nos agendas surchargés. Le juste équilibre entre discipline et bienveillance. Résultat : -10 kg sur la balance et un bien-être retrouvé ! Et on continue cette année ! 💪",
      date: "Il y a 2 mois"
    },
    {
      id: 2,
      name: "Roselyne Bullmann",
      rating: 5,
      text: "Un coach en or. Dès la 1ère séance, je crois que Kévin m'a cernée avant même que j'aie besoin de parler. Chaque séance est différente, pensée sur mesure, et toujours avec beaucoup de bienveillance. Il vous fait vous dépasser juste ce qu'il faut pour vous rendre fière de vous. Au-delà du sport, il m'accompagne aussi sur la nutrition et le bien-être, avec une vraie écoute et une attention sincère.",
      date: "Il y a 1 mois"
    },
    {
      id: 3,
      name: "Elise Sabbah",
      rating: 5,
      text: "Kevin est un coach sportif digne de ce nom et ce n'est pas ma première expérience avec un coach ! Il est passionné et a beaucoup de connaissances techniques. Grace à lui j'ai pu atteindre mes objectifs, en créant une vraie relation de confiance. Je me suis sentie accompagnée mais surtout comprise et soutenue ! Il a développé mes forces physiques mais surtout mentales. Une vraie et belle rencontre !",
      date: "Il y a 3 semaines"
    },
    {
      id: 4,
      name: "Mylène Cabon",
      rating: 5,
      text: "Je recommande à 200 % ! Kevin est un coach avenant, toujours présent pour ses coachés, et surtout expert dans l'art de te faire sortir de ta zone de confort sans même que tu t'en rendes compte. Il te pousse à te dépasser tout en veillant à ta sécurité — un équilibre parfait entre bienveillance et « Allez, encore une dernière ! ». Toujours à l'écoute de tes besoins et de tes capacités, il sait adapter chaque séance pour te faire progresser.",
      date: "Il y a 2 semaines"
    },
    {
      id: 5,
      name: "Mélanie Rouers",
      rating: 5,
      text: "A tes côtés j'ai passé 6 mois intenses ! Un programme au top avec des séances variées : de l'haltero, du crossfit, de la course, de la boxe, il y en a pour tous les goûts ! Le suivi est top, un accompagnement alimentaire et des devoirs maison pour compléter la séance hebdomadaire ! Kevin sait exactement jusqu'où il peut vous pousser alors faites lui confiance !!",
      date: "Il y a 3 mois"
    },
    {
      id: 6,
      name: "Grégory Boutet",
      rating: 5,
      text: "Sans lui, je n'aurais jamais atteint mes objectifs. Grâce à Kevin, j'ai non seulement pris du muscle et perdu du poids, mais j'ai aussi énormément évolué sur le plan personnel. Kevin est un coach très professionnel, passionné, qui sait exactement de quoi il parle. Il est aussi extrêmement humain, solaire, toujours à l'écoute, souriant et empathique. Je recommande ce coach les yeux fermés !",
      date: "Il y a 1 mois"
    }
  ],

  faqs: [
    {
      question: "Est-ce adapté aux débutants ?",
      answer: "Absolument ! Que tu sois débutant ou confirmé, le coaching est adapté à ton niveau. Tu n'as pas besoin d'être déjà sportif pour commencer."
    },
    {
      question: "Proposes-tu un suivi nutritionnel ?",
      answer: "Oui, le suivi nutritionnel est inclus dans l'accompagnement. Tu reçois un plan alimentaire personnalisé adapté à tes objectifs et ton mode de vie."
    },
    {
      question: "Le coaching se déroule en salle ou à domicile ?",
      answer: "Les deux options sont possibles ! Nous pouvons nous retrouver en salle de sport ou je peux me déplacer à ton domicile selon tes préférences."
    },
    {
      question: "Combien de temps avant de voir des résultats ?",
      answer: "Les premiers résultats sont généralement visibles dès les 3-4 premières semaines avec un engagement régulier. La transformation durable se construit sur 3 à 6 mois."
    },
    {
      question: "Comment se déroule une première séance ?",
      answer: "La première séance est un bilan complet : on discute de tes objectifs, ton historique sportif, tes habitudes alimentaires. Ensuite, on établit ensemble ton programme personnalisé."
    },
    {
      question: "Faut-il déjà être sportif pour commencer ?",
      answer: "Pas du tout ! Le coaching s'adapte à ton niveau actuel. L'important c'est ta motivation, je m'occupe du reste."
    },
    {
      question: "Quel est le tarif du coaching ?",
      answer: "Les tarifs varient selon la formule choisie (nombre de séances par semaine, suivi nutrition inclus ou non). Contacte-moi pour un devis personnalisé adapté à tes besoins."
    },
    {
      question: "Où se déroulent les séances ?",
      answer: "Les séances ont lieu à Lingolsheim et alentours. Je peux me déplacer à domicile ou nous retrouver en salle selon ta préférence."
    }
  ],

  coachBio: {
    name: "Kevin",
    title: "Coach Sportif & Nutritionnel",
    description: "Passionné de sport depuis toujours, j'ai fait de ma passion mon métier. Mon objectif : t'accompagner vers la meilleure version de toi-même, dans la bonne humeur et avec des résultats durables.",
    qualities: [
      "Diplômé et certifié en coaching sportif",
      "Spécialisé en nutrition sportive",
      "Plus de 5 ans d'expérience",
      "Accompagnement bienveillant et motivant"
    ],
    philosophy: "Je crois que chaque personne mérite un accompagnement sur-mesure. Pas de solution miracle, mais du travail, de la motivation et surtout de la bonne humeur. Ensemble, on va créer LE déclic qui changera ta vie."
  }
};
